module.exports = __webpack_public_path__ + "static/media/U region.7d4f23f3.kra";